import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";

export interface IExtraData {
  property: IProperty;
  hasRentMatchForBroker?: boolean;
  /** Broker's listing URL template (e.g. https://immo.be/te-huur/[ID]) */
  listingUrlTemplate?: string | null;
  /** Broker's for rent page fallback URL */
  websiteUrl?: string | null;
  /** Amenity: number of bathrooms (not on IProperty directly) */
  roomCountBathroom?: number | null;
  /** Amenity: number of garages (not on IProperty directly) */
  roomCountGarage?: number | null;
  /** Amenity: building surface area m² (not on IProperty directly) */
  buildingSurfaceArea?: number | null;
}

export enum EField {
  Header = "_header",
  RentMatchIntro = "_rentMatchIntro",
  Price = "price",
  Costs = "costs",
  IsRentMatchPublished = "isRentMatchPublished",
  RoomCountBedroom = "roomCountBedroom",
  AvailableAtDate = "availableAtDate",
  ExternalListingUrl = "externalListingUrl",
  ExtraDetailsHeader = "_extraDetailsHeader",
  RoomCountBathroom = "roomCountBathroom",
  RoomCountGarage = "roomCountGarage",
  BuildingSurfaceArea = "buildingSurfaceArea",
  EpcLabel = "epcLabel",
  BuildingTerraceSurfaceArea = "buildingTerraceSurfaceArea",
  BuildingGardenSurfaceArea = "buildingGardenSurfaceArea",
}
